import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

import { Constants } from 'app/util/constant.model';

import * as jwt_decode from 'jwt-decode';
import * as moment from 'moment';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
    providedIn: 'root'
})
export class UtilidadesService {

    constructor() { }

    obtenerNombreMes(val: Date): any {
        let rspta: any = "";

        switch (val.getMonth()) {
            case 0: {
                rspta = "Enero";
                break;
            }
            case 1: {
                rspta = "Febrero";
                break;
            }
            case 2: {
                rspta = "Marzo";
                break;
            }
            case 3: {
                rspta = "Abril";
                break;
            }
            case 4: {
                rspta = "Mayo";
                break;
            }
            case 5: {
                rspta = "Junio";
                break;
            }
            case 6: {
                rspta = "Julio";
                break;
            }
            case 7: {
                rspta = "Agosto";
                break;
            }
            case 8: {
                rspta = "Septiembre";
                break;
            }
            case 9: {
                rspta = "Octubre";
                break;
            }
            case 10: {
                rspta = "Noviembre";
                break;
            }
            case 11: {
                rspta = "Diciembre";
                break;
            }
            default: {
                rspta = "";
                break;
            }
        }

        return rspta;
    }

    obtenerNombreMesNumero(val: any): any {
        let rspta: any = "";

        switch (val) {
            case 1: {
                rspta = "Enero";
                break;
            }
            case 2: {
                rspta = "Febrero";
                break;
            }
            case 3: {
                rspta = "Marzo";
                break;
            }
            case 4: {
                rspta = "Abril";
                break;
            }
            case 5: {
                rspta = "Mayo";
                break;
            }
            case 6: {
                rspta = "Junio";
                break;
            }
            case 7: {
                rspta = "Julio";
                break;
            }
            case 8: {
                rspta = "Agosto";
                break;
            }
            case 9: {
                rspta = "Septiembre";
                break;
            }
            case 10: {
                rspta = "Octubre";
                break;
            }
            case 11: {
                rspta = "Noviembre";
                break;
            }
            case 12: {
                rspta = "Diciembre";
                break;
            }
            default: {
                rspta = "";
                break;
            }
        }

        return rspta;
    }

    listarMeses(): any {
        return [{ id: 1, nombre: 'Enero' }, { id: 2, nombre: 'Febrero' }, { id: 3, nombre: 'Marzo' }, { id: 4, nombre: 'Abril' }, { id: 5, nombre: 'Mayo' }, { id: 6, nombre: 'Junio' }, { id: 7, nombre: 'Julio' }, { id: 8, nombre: 'Agosto' }, { id: 9, nombre: 'Septiembre' }, { id: 10, nombre: 'Octubre' }, { id: 11, nombre: 'Noviembre' }, { id: 12, nombre: 'Diciembre' }];
    }

    obtenerFechaActualFormato(): any {

        let rspta: any = {
            dd: "", mm: "", yyyy: "", fecha: ""
        };

        var today = new Date();
        rspta.dd = String(today.getDate()).padStart(2, '0');
        rspta.mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        rspta.yyyy = today.getFullYear();

        rspta.fecha = rspta.dd + '/' + rspta.mm + '/' + rspta.yyyy;

        return rspta;
    }

    obtenerFechaFormato(fecha: Date): any {

        let rspta: any = {
            dd: "", mm: "", yyyy: "", fecha: ""
        };

        rspta.dd = String(fecha.getDate()).padStart(2, '0');
        rspta.mm = String(fecha.getMonth() + 1).padStart(2, '0'); //January is 0!
        rspta.yyyy = fecha.getFullYear();

        rspta.fecha = rspta.dd + '/' + rspta.mm + '/' + rspta.yyyy;

        return rspta;
    }

    obtenerFechaPrimerDiaAnioActual(dia: string, mes: string): any {

        let rspta: any = {
            dd: "", mm: "", yyyy: "", fecha: ""
        };

        let fechaactual = new Date();

        rspta.dd = dia;
        rspta.mm = mes;
        rspta.yyyy = fechaactual.getFullYear();

        rspta.fecha = rspta.dd + '/' + rspta.mm + '/' + rspta.yyyy;

        return rspta;
    }

    obtenerFechaDesdeHasta(fecha: Date, mesagregado: number): any {

        let response: any = {
            desde: "", hasta: ""
        };

        let fechadesde = new Date(fecha.getFullYear(), fecha.getMonth(), 1);
        let fechaHasta = new Date(fecha.getFullYear(), (fecha.getMonth() + 1), 0);

        response.desde = (
            (fechadesde.getDate().toString().length == 1 ? "0" + fechadesde.getDate() : fechadesde.getDate())
            + "/" + ((fechadesde.getMonth() + mesagregado).toString().length == 1 ? "0" + (fechadesde.getMonth() + mesagregado) : (fechadesde.getMonth() + mesagregado))
            + "/" + fechadesde.getFullYear());

        response.hasta = (
            ((fechaHasta.getDate()).toString().length == 1 ? "0" + fechaHasta.getDate() : fechaHasta.getDate())
            + "/" + ((fechaHasta.getMonth() + mesagregado).toString().length == 1 ? "0" + (fechaHasta.getMonth() + mesagregado) : (fechaHasta.getMonth() + mesagregado))
            + "/" + fechaHasta.getFullYear());

        return response;
    }

    obtenerFechaDesdeHasta2(mes: number, anio: number): any {

        let response: any = {
            desde: "", hasta: ""
        };

        let fechaactual = new Date();
        let fechadesde = new Date(anio, (mes - 1), 1);
        let fechaHasta = new Date(anio, mes, 0);

        response.desde = (
            (fechadesde.getDate().toString().length == 1 ? "0" + fechadesde.getDate() : fechadesde.getDate())
            + "/" + ((fechadesde.getMonth() + 1).toString().length == 1 ? "0" + (fechadesde.getMonth() + 1) : (fechadesde.getMonth() + 1))
            + "/" + fechadesde.getFullYear());

        response.hasta = (fechaactual.getMonth() + 1 == mes && fechaactual.getFullYear() == anio)
            ? (((fechaactual.getDate()).toString().length == 1 ? "0" + fechaactual.getDate() : fechaactual.getDate())
                + "/" + ((fechaactual.getMonth() + 1).toString().length == 1 ? "0" + (fechaactual.getMonth() + 1) : (fechaactual.getMonth() + 1))
                + "/" + fechaactual.getFullYear())
            : (((fechaHasta.getDate()).toString().length == 1 ? "0" + fechaHasta.getDate() : fechaHasta.getDate())
                + "/" + ((fechaHasta.getMonth() + 1).toString().length == 1 ? "0" + (fechaHasta.getMonth() + 1) : (fechaHasta.getMonth() + 1))
                + "/" + fechaHasta.getFullYear());

        return response;
    }

    obtenerPrimerFinDiaSemanaActualFormato(): any {

        let response: any = {
            desde: "", hasta: ""
        };

        var fechaactual = moment();

        response.desde = moment(fechaactual).subtract(fechaactual.day() - 1, 'days');
        response.hasta = moment(fechaactual).add(7 - fechaactual.day(), 'days');

        return response;
    }

    obtenerPrimerDiaMesActualFormato(): any {

        let response: any = {
            desde: "", hasta: ""
        };

        var fechaactual = moment();

        response.desde = moment(fechaactual).subtract(fechaactual.date() - 1, 'days');
        response.hasta = moment(fechaactual);

        return response;
    }

    getHttpOptionsHeaderWithToken() {

        return {
            headers: new HttpHeaders({
                'Content-type': 'application/json; charset=utf-8',
                //'Access-Control-Allow-Origin': '*',
                'token': window.localStorage.getItem('token')
            })
        };
    }

    obtenerValoresToken(valor: any): any {
        var decoded = jwt_decode(window.localStorage.getItem('token'));
        return valor.length != 0 ? JSON.parse(decoded["sub"])[valor] : JSON.parse(decoded["sub"]);
    }

    exportAsExcelFile(json: any[], excelFileName: string): void {
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
        const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, excelFileName);
    }

    saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
        FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
    }

    async obtenerPerfilDependeciaFromToken() {  //obtenerPerfilDependenciaFromToken

        let iddependencia = Constants.val_const_dependencia_rrhh;
        let idperfil = Constants.val_const_perfil_servidor;

        if (this.obtenerValoresToken(Constants.val_val_token_listVwContratoPerfilDto)[0]["idperfil"] == Constants.val_const_perfil_rrhh && this.obtenerValoresToken(Constants.val_val_token_iddependencia) == Constants.val_const_dependencia_rrhh
            || this.obtenerValoresToken(Constants.val_val_token_iddependenciadesignado) == Constants.val_const_dependencia_rrhh
            || this.obtenerValoresToken(Constants.val_val_token_iddependenciaencargado) == Constants.val_const_dependencia_rrhh
            || this.obtenerValoresToken(Constants.val_val_token_listVwContratoPerfilDto)[0]["idperfil"] == Constants.val_const_perfil_admin
        ) {
            iddependencia = await Number(this.obtenerValoresToken(Constants.val_val_token_iddependencia));
            idperfil = Constants.val_const_perfil_rrhh;

        } else if (this.obtenerValoresToken(Constants.val_val_token_listVwContratoPerfilDto)[0]["idperfil"] == Constants.val_const_perfil_rrhh_planilla && this.obtenerValoresToken(Constants.val_val_token_iddependencia) == Constants.val_const_dependencia_rrhh) {

            iddependencia = await Number(this.obtenerValoresToken(Constants.val_val_token_iddependencia));
            idperfil = Constants.val_const_perfil_rrhh_planilla;

        } else if (this.obtenerValoresToken(Constants.val_val_token_listVwContratoPerfilDto)[0]["idperfil"] == Constants.val_const_perfil_rrhh_salud && this.obtenerValoresToken(Constants.val_val_token_iddependencia) == Constants.val_const_dependencia_rrhh) {

            iddependencia = await Number(this.obtenerValoresToken(Constants.val_val_token_iddependencia));
            idperfil = Constants.val_const_perfil_rrhh_salud;

        } else if (this.obtenerValoresToken(Constants.val_val_token_listVwContratoPerfilDto)[0]["idperfil"] == Constants.val_const_perfil_rrhh_personal && this.obtenerValoresToken(Constants.val_val_token_iddependencia) == Constants.val_const_dependencia_rrhh) {

            iddependencia = await Number(this.obtenerValoresToken(Constants.val_val_token_iddependencia));
            idperfil = Constants.val_const_perfil_rrhh_personal;

        } else if (this.obtenerValoresToken(Constants.val_val_token_iddependenciadesignado) != undefined) {

            if (this.obtenerValoresToken(Constants.val_val_token_iddependenciadesignadosuperior) != undefined) {
                iddependencia = await Number(this.obtenerValoresToken(Constants.val_val_token_iddependenciadesignadosuperior).split(',')[0]);
            } else {
                iddependencia = await Constants.val_const_dependencia_direccion_ejecutiva;
            }
            idperfil = Constants.val_const_perfil_responsable;

        } else if (this.obtenerValoresToken(Constants.val_val_token_iddependenciaencargado) != undefined) {

            if (this.obtenerValoresToken(Constants.val_val_token_iddependenciaencargadosuperior) != undefined) {
                iddependencia = await Number(this.obtenerValoresToken(Constants.val_val_token_iddependenciaencargadosuperior).split(',')[0]);
            } else {
                iddependencia = await Constants.val_const_dependencia_direccion_ejecutiva;
            }

            idperfil = Constants.val_const_perfil_responsable;
        } else {
            iddependencia = await Number(this.obtenerValoresToken(Constants.val_val_token_iddependencia));
            idperfil = Constants.val_const_perfil_servidor;
        }

        return { iddependencia: iddependencia, idperfil: idperfil };
    }

}
